export const DEFAULT_MEMORY_GAME_DATA = {
  pairs: [
    { id: "pair-1", imageUrl: "https://example.com/image-1.jpg", description: "" },
    { id: "pair-2", imageUrl: "https://example.com/image-2.jpg", description: "" },
    { id: "pair-3", imageUrl: "https://example.com/image-3.jpg", description: "" },
    { id: "pair-4", imageUrl: "https://example.com/image-4.jpg", description: "" },
  ],
  settings: {
    pairCount: 4,
    cardBackImageUrl: "https://example.com/card-back.jpg",
    timerSeconds: null,
    showMatchSuccessPopup: false,
    memoryMatchSuccessMessage: "",
  },
};

export const DEFAULT_MEMORY_INTRO = {
  title: "Memory Game",
  instructions:
    "Test your memory by matching pairs of images to clear the board.",
  howTo:
    "Press on a card to reveal the face side. Remember where the face side exists on the board and see if you can find the same image.Match pairs of cards by selecting pairs of the same face side images",
};

export const DEFAULT_MEMORY_FORM_FIELDS = {
  introMessage: DEFAULT_MEMORY_INTRO,
  gameData: DEFAULT_MEMORY_GAME_DATA,
  terms: "",
  termsType: "none",
  makeGradient: false,
  backgroundColor: "#FFFFFF",
  backgroundImage: "",
  bannerImage: "",
  textColor: "#000000",
  buttonColor: "#000000",
  categoryColors: ["#DE183B", "#60116A", "#333333", "#666666"],
  cardBackgroundColor: "#FFFFFF",
  cardTextColor: "#000000",
  categoryTextColor: "#FFFFFF",
  successMessage: "Congratulations, you got it!",
  redirectButtonText: "Click to enter for a chance to win!",
  redirectButtonLink: "",
  redirectButtonColor: "#DE183B",
  reveal: {
    title: "Congratulations!",
    src: "",
    description: "You completed the game!",
  },
};
